import { LitElement, html } from 'lit';
import { provide } from '@lit/context';
import { customElement, state } from 'lit/decorators.js';
import { wishlistContext } from './wishlist-context';
import GiftReggieService from '../utils/gift-reggie';

@customElement('app-provider')
class AppProvider extends LitElement {
  @provide({ context: wishlistContext })
  @state()
  accessor wishlist = new GiftReggieService();

  render() {
    return html`<slot></slot>`;
  }
}

export default AppProvider;
